module.exports = __webpack_public_path__ + "img/52-ABITO-ELECTRA-SML-COLORI-LINO-STAMPE-LINO1.1768d89c.jpg";